module.exports = __webpack_public_path__ + "img/img11.eb5a70b4.png";